export {default as dispatch} from "./dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3-dispatch/src/index.js
// module id = 191
// module chunks = 0